<template>
  <section class="px-4 py-12 md:py-16 bg-neutral-700">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.compare.title') }}</h2>

      <div class="w-full mt-4 overflow-x-auto">
        <table class="w-full min-w-[40rem] table-fixed text-left border-separate border-spacing-0">
          <thead>
            <tr>
              <th class="p-3" />
              <th
                v-for="option in OPTIONS"
                :key="option"
                class="p-3 align-bottom font-extrabold"
                :class="option === 'soundz' ? 'bg-neutral-800 rounded-t-2xl text-primary' : ''"
              >
                {{ t(`landing.compare.${option}.name`) }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in ROWS" :key="row">
              <th class="p-3 font-normal text-neutral-300 border-t border-neutral-500">
                {{ t(`landing.compare.rows.${row}`) }}
              </th>
              <td
                v-for="option in OPTIONS"
                :key="option"
                class="p-3 border-t border-neutral-500"
                :class="[
                  option === 'soundz' ? 'bg-neutral-800' : '',
                  option === 'soundz' && index === ROWS.length - 1 ? 'rounded-b-2xl' : '',
                ]"
              >
                {{ t(`landing.compare.${option}.${row}`) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="text-sm text-neutral-300 mt-6">{{ t('landing.compare.footnote') }}</p>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const OPTIONS = ['adRadio', 'streaming', 'soundz'] as const
const ROWS = ['cost', 'ads', 'ownSpots', 'talk', 'commercialUse'] as const
</script>
